import React, { useState, useRef, useEffect } from 'react';
import './Chatbot.css';
import { FaComments, FaTimes, FaPaperPlane, FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import churchLogo from '../../assets/churchlogoPic.png';

const BOT_AVATAR = churchLogo;

const QUICK_OPTIONS = [
  { label: 'Service Times', value: 'What are your service times?' },
  { label: 'Events', value: 'What events are coming up?' },
  { label: 'Ministries', value: 'Tell me about your ministries' },
  { label: 'Social Media', value: 'Where can I follow you on social media?' },
  { label: 'Location', value: 'Where is the church located?' },
  { label: 'Contact', value: 'How can I contact the church?' },
];

const CONTACT_INFO = {
  phone: '(267) 984-3132',
  email: 'philadelphiashalemag@gmail.com',
  facebook: 'https://www.facebook.com/psagchurch',
  instagram: 'https://www.instagram.com/psagchurch/',
  youtube: 'https://www.youtube.com/@psagchurch',
  address: '2840 Holme Ave, Philadelphia PA 19152',
};

const SERVICE_TIMES_TEXT = 'Our service times are:\n• Friday Prayer: 7:30 PM\n• Saturday Prayer: 6:30 PM\n• Sunday School: 9:00 AM\n• Sunday Service: 9:45 AM';

function ContactCard() {
  const d = CONTACT_INFO;
  return (
    <div className="chatbot-contact-card chatbot-deflection-card">
      <div className="chatbot-contact-title">Reach out directly</div>
      <div className="chatbot-contact-details">
        <div><span className="chatbot-contact-label">Phone</span> <a className="chatbot-contact-link" href={`tel:${d.phone.replace(/\D/g, '')}`}>{d.phone}</a></div>
        <div><span className="chatbot-contact-label">Email</span> <a className="chatbot-contact-link" href={`mailto:${d.email}`}>{d.email}</a></div>
        <div><span className="chatbot-contact-label">Address</span> {d.address}</div>
      </div>
      <div className="chatbot-contact-btns">
        <a className="chatbot-action-btn" href={`tel:${d.phone.replace(/\D/g, '')}`}>Call</a>
        <a className="chatbot-action-btn" href={`mailto:${d.email}`}>Email</a>
        <a className="chatbot-action-btn" href={d.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>
        <a className="chatbot-action-btn" href={d.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>
        <a className="chatbot-action-btn" href={d.youtube} target="_blank" rel="noopener noreferrer">YouTube</a>
      </div>
    </div>
  );
}

function renderBotContent(content, suggestContact) {
  if (content === 'social') {
    return (
      <div className="chatbot-social-card">
        <div className="chatbot-social-title">Connect with us</div>
        <div className="chatbot-social-icons">
          <a href={CONTACT_INFO.facebook} target="_blank" rel="noopener noreferrer" className="chatbot-social-icon" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href={CONTACT_INFO.instagram} target="_blank" rel="noopener noreferrer" className="chatbot-social-icon" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href={CONTACT_INFO.youtube} target="_blank" rel="noopener noreferrer" className="chatbot-social-icon" aria-label="YouTube">
            <FaYoutube />
          </a>
        </div>
      </div>
    );
  }
  if (content === 'events') {
    return (
      <div>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>Upcoming events</div>
        <div>We have regular services and special events throughout the year. All-Night Prayer (last Friday of each month), CA Meeting (2nd Saturdays), Ladies&apos; Meeting (2nd Sundays), and more. For the latest schedule, visit our website or the Plan Your Visit page.</div>
        <a className="chatbot-action-btn" href="/visit-us" style={{ marginTop: 10, display: 'inline-block' }}>Plan Your Visit</a>
      </div>
    );
  }
  if (content === 'ministries') {
    return (
      <div className="chatbot-info-card">
        <div className="chatbot-info-title">Our Ministries</div>
        <div className="chatbot-info-desc">We do Watch Night, India Mission, Street Mission, Bootcamp, Community Outreach, Music Night, and more. Explore how you can get involved.</div>
        <a className="chatbot-action-btn" href="/ministries">View Ministries</a>
      </div>
    );
  }
  if (/social|facebook|instagram|youtube|follow|subscribe/i.test(content)) {
    return (
      <div className="chatbot-social-card">
        <div className="chatbot-social-title">Connect with us</div>
        <div className="chatbot-social-icons">
          <a href={CONTACT_INFO.facebook} target="_blank" rel="noopener noreferrer" className="chatbot-social-icon" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href={CONTACT_INFO.instagram} target="_blank" rel="noopener noreferrer" className="chatbot-social-icon" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href={CONTACT_INFO.youtube} target="_blank" rel="noopener noreferrer" className="chatbot-social-icon" aria-label="YouTube">
            <FaYoutube />
          </a>
        </div>
      </div>
    );
  }
  if (/service|time(s)?|schedule|when (do you|are you)|sunday|friday|saturday|worship|prayer/i.test(content)) {
    return (
      <div>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>Our service times</div>
        <ul className="chatbot-bullets">
          <li>Friday Prayer: 7:30 PM</li>
          <li>Saturday Prayer: 6:30 PM</li>
          <li>Sunday School: 9:00 AM</li>
          <li>Sunday Service: 9:45 AM</li>
        </ul>
      </div>
    );
  }
  if (/location|address|where|map|directions/i.test(content)) {
    return (
      <div>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>Our location</div>
        <div className="chatbot-location">{CONTACT_INFO.address}</div>
        <a className="chatbot-action-btn" href="https://maps.google.com/?q=2840+Holme+Ave,+Philadelphia+PA+19152" target="_blank" rel="noopener noreferrer">View on Map</a>
      </div>
    );
  }
  if (/contact|phone|email|call|reach|speak to/i.test(content)) {
    return (
      <div>
        <div>You can reach us by phone or email. Here are the details:</div>
        <ContactCard />
      </div>
    );
  }
  if (/pastor|minister|leader/i.test(content)) {
    return (
      <div>
        Our pastor is <strong>Pr. Sajan George</strong>, who has been leading PSAG Church since its establishment in 2014. For pastoral care or to connect with him, please call or email us—we’d be glad to help.
      </div>
    );
  }
  if (/about|who are you|what is psag|church info/i.test(content)) {
    return (
      <div>
        We are <strong>Philadelphia Shalem Assembly of God</strong>, a Malayalee Pentecostal church in Philadelphia. We’re dedicated to fellowship, worship, and service—a place where creation meets the Creator. You can ask me about service times, location, events, or contact info.
      </div>
    );
  }
  if (/ministr(y|ies)/i.test(content)) {
    return (
      <div className="chatbot-info-card">
        <div className="chatbot-info-title">Our Ministries</div>
        <div className="chatbot-info-desc">We have ministries for all ages and interests.</div>
        <a className="chatbot-action-btn" href="/ministries">View Ministries</a>
      </div>
    );
  }
  if (/gallery|photos|pictures/i.test(content)) {
    return (
      <div className="chatbot-info-card">
        <div className="chatbot-info-title">Gallery</div>
        <div className="chatbot-info-desc">See photos and memories from our church family.</div>
        <a className="chatbot-action-btn" href="/gallery">View Gallery</a>
      </div>
    );
  }
  if (/event(s)?|upcoming|what('s| is) on/i.test(content)) {
    return (
      <div>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>Upcoming events</div>
        <div>We have regular services and special events throughout the year. All-Night Prayer (last Friday of each month), CA Meeting (2nd Saturdays), Ladies&apos; Meeting (2nd Sundays), and more. For the latest schedule, visit our website or the Plan Your Visit page.</div>
        <a className="chatbot-action-btn" href="/visit-us" style={{ marginTop: 10, display: 'inline-block' }}>Plan Your Visit</a>
      </div>
    );
  }
  if (/new here|first time|visit|plan (my )?visit/i.test(content)) {
    return (
      <div className="chatbot-info-card">
        <div className="chatbot-info-title">New Here?</div>
        <div className="chatbot-info-desc">We’d love to welcome you. Find service times, what to expect, and how to get in touch.</div>
        <a className="chatbot-action-btn" href="/new-here">New Here</a>
        <a className="chatbot-action-btn" href="/visit-us" style={{ marginTop: 8 }}>Plan Your Visit</a>
      </div>
    );
  }
  if (/donate|giving|offer|tithes/i.test(content)) {
    return (
      <div>
        For giving and donations, please visit our Give page or contact us by phone or email. We’re happy to help with any questions.
        <a className="chatbot-action-btn" href="/give" style={{ marginTop: 10, display: 'inline-block' }}>Give</a>
      </div>
    );
  }
  if (/beliefs|belief|values|what (do you )?believe/i.test(content)) {
    return (
      <div className="chatbot-info-card">
        <div className="chatbot-info-title">Our Beliefs</div>
        <div className="chatbot-info-desc">Learn about what we believe and our values.</div>
        <a className="chatbot-action-btn" href="/beliefs">Our Beliefs</a>
      </div>
    );
  }
  if (/watch|live|stream|online (service)?/i.test(content)) {
    return (
      <div className="chatbot-info-card">
        <div className="chatbot-info-title">Watch</div>
        <div className="chatbot-info-desc">Watch our services and messages online.</div>
        <a className="chatbot-action-btn" href="/watch">Watch</a>
      </div>
    );
  }
  if (/hello|hi|hey|good morning|good evening/i.test(content) && content.split(/\s/).length <= 4) {
    return (
      <div>
        Hello! Thanks for reaching out. I’m here to help with service times, location, contact info, events, and more. What would you like to know?
      </div>
    );
  }
  if (/thank(s| you)/i.test(content)) {
    return (
      <div>
        You’re welcome! If you have any other questions, just ask. We’d love to see you at PSAG Church.
      </div>
    );
  }
  if (/help|human|real person|talk to someone|agent|staff/i.test(content) || suggestContact) {
    return (
      <div>
        {content.match(/help|human|real person|talk to someone|agent|staff/i)
          ? "I’m happy to connect you with our team. You can call, email, or message us on social media—we’re here to help."
          : "For more specific or personal questions, the best next step is to reach out directly. Here’s how you can contact us:"}
        <ContactCard />
      </div>
    );
  }
  return (
    <div>
      {content.split('\n').map((line, i) => <div key={i}>{line}</div>)}
      {suggestContact && <ContactCard />}
    </div>
  );
}

function getBotResponse(message, userMessageCount) {
  const lower = message.toLowerCase().trim();
  const suggestAfter = 5;

  if (/social|facebook|instagram|youtube|follow (you |us )?(on )?social|subscribe/i.test(lower)) {
    return { content: 'social', suggestContact: false };
  }
  if (/event(s)?|upcoming|what('s| is) on|coming up/i.test(lower)) {
    return { content: 'events', suggestContact: userMessageCount >= 4 };
  }
  if (/service|time(s)?|schedule|when (do you|are you)|sunday|friday|saturday|worship|prayer/i.test(lower)) {
    return { content: SERVICE_TIMES_TEXT, suggestContact: false };
  }
  if (/location|address|where (is|are)|map|directions/i.test(lower)) {
    return { content: `We're at ${CONTACT_INFO.address}.`, suggestContact: false };
  }
  if (/contact|phone|email|call|reach|speak to/i.test(lower)) {
    return { content: 'You can reach us by phone or email.', suggestContact: true };
  }
  if (/ministr(y|ies)/i.test(lower)) {
    return { content: 'ministries', suggestContact: false };
  }
  if (/pastor|minister|leader/i.test(lower)) {
    return { content: 'Our pastor is Pr. Sajan George, leading PSAG Church since 2014. For pastoral care, please call or email us.', suggestContact: userMessageCount >= 3 };
  }
  if (/about|who are you|what is psag|church info/i.test(lower)) {
    return { content: "We're Philadelphia Shalem Assembly of God, a Malayalee Pentecostal church in Philadelphia—fellowship, worship, and service.", suggestContact: false };
  }
  if (/gallery|photos|pictures/i.test(lower)) {
    return { content: 'gallery', suggestContact: false };
  }
  if (/new here|first time|visit|plan (my )?visit/i.test(lower)) {
    return { content: 'newhere', suggestContact: false };
  }
  if (/donate|giving|offer|tithes/i.test(lower)) {
    return { content: 'For giving, visit our Give page or contact us.', suggestContact: false };
  }
  if (/beliefs|belief|values/i.test(lower)) {
    return { content: 'beliefs', suggestContact: false };
  }
  if (/watch|live|stream|online/i.test(lower)) {
    return { content: 'watch', suggestContact: false };
  }
  if (/hello|hi|hey|good morning|good evening/i.test(lower) && lower.split(/\s/).length <= 4) {
    return { content: "Hello! I'm here to help with service times, location, contact info, events, and more. What would you like to know?", suggestContact: false };
  }
  if (/thank(s| you)/i.test(lower)) {
    return { content: "You're welcome! If you have any other questions, just ask.", suggestContact: false };
  }
  if (/help|human|real person|talk to someone|agent|staff/i.test(lower)) {
    return { content: 'I’m happy to connect you with our team. You can call, email, or message us on social media.', suggestContact: true };
  }

  const suggestContact = userMessageCount >= suggestAfter;
  return {
    content: "I can help with service times, location, contact info, events, ministries, and more. Try one of the quick options below or ask something like “What are your service times?” or “Where are you located?” For detailed or personal questions, we’d love to hear from you directly.",
    suggestContact,
  };
}

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { type: 'bot', content: "Hi! I'm the PSAG Church assistant. Ask me about service times, location, events, or contact info—or tap a quick option below.", suggestContact: false }
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const [showNotification, setShowNotification] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (!isOpen && showNotification) {
      const t = setTimeout(() => setShowNotification(false), 10000);
      return () => clearTimeout(t);
    }
  }, [isOpen, showNotification]);
  useEffect(() => {
    if (isOpen && showNotification) setShowNotification(false);
  }, [isOpen, showNotification]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const userCount = messages.filter(m => m.type === 'user').length;

  const handleSend = (userMsg) => {
    if (!userMsg.trim()) return;
    setInputMessage('');
    setMessages(prev => [...prev, { type: 'user', content: userMsg.trim() }]);
    setIsLoading(true);
    const nextUserCount = userCount + 1;
    setTimeout(() => {
      const { content, suggestContact } = getBotResponse(userMsg.trim(), nextUserCount);
      setMessages(prev => [
        ...prev,
        { type: 'bot', content, suggestContact },
      ]);
      setIsLoading(false);
    }, 600);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSend(inputMessage);
  };

  const handleQuickOption = (value) => {
    handleSend(value);
  };

  return (
    <div className="chatbot-container">
      {!isOpen && (
        <>
          {showNotification && (
            <div className="chatbot-notification">
              <b>Chat with us</b>
            </div>
          )}
          <button className="chatbot-button" onClick={() => setIsOpen(true)} aria-label="Open chat">
            <FaComments />
          </button>
        </>
      )}
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <div className="chatbot-title">
              <FaComments style={{ marginRight: 8 }} />
              <span>PSAG Assistant</span>
            </div>
            <button className="close-button" onClick={() => setIsOpen(false)} aria-label="Close chat">
              <FaTimes />
            </button>
          </div>
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`message-row ${msg.type === 'bot' ? 'bot-row' : 'user-row'}`}>
                {msg.type === 'bot' && (
                  <img src={BOT_AVATAR} alt="PSAG" className="bot-avatar" />
                )}
                <div className={`message ${msg.type}`}>
                  {msg.type === 'bot'
                    ? renderBotContent(msg.content, msg.suggestContact)
                    : msg.content}
                </div>
              </div>
            ))}
            {isLoading && (
              <div className="message-row bot-row">
                <img src={BOT_AVATAR} alt="PSAG" className="bot-avatar" />
                <div className="message bot chatbot-typing">
                  <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
                </div>
              </div>
            )}
            <div className="chatbot-quick-options">
              {QUICK_OPTIONS.map(opt => (
                <button
                  key={opt.label}
                  type="button"
                  className="chatbot-quick-btn"
                  onClick={() => handleQuickOption(opt.value)}
                  disabled={isLoading}
                >
                  {opt.label}
                </button>
              ))}
            </div>
            <div ref={messagesEndRef} />
          </div>
          <form className="chatbot-input" onSubmit={handleSubmit}>
            <input
              type="text"
              value={inputMessage}
              onChange={e => setInputMessage(e.target.value)}
              placeholder="Type your message..."
              aria-label="Message"
              disabled={isLoading}
            />
            <button type="submit" aria-label="Send" disabled={isLoading}>
              <FaPaperPlane />
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
